import React, { createContext } from 'react'
import { usePersistedState } from '../hooks'

const initialValue = {
  selectionState: {},
  setSelectionState: () => {},
}

const SelectionContext = createContext(initialValue)

function SelectionProvider({ children }) {
  const [selectionState, setSelectionState] = usePersistedState(
    LS_SELECTION_KEY,
    {}
  )
  return (
    <SelectionContext.Provider
      value={{
        selectionState,
        setSelectionState,
      }}
    >
      {children}
    </SelectionContext.Provider>
  )
}

export default SelectionContext
export { SelectionProvider }
export const LS_SELECTION_KEY = 'pxmusic_selection'
